import { createFeatureFlags } from '@sitecore/featureflags';

export const {
	Feature,
	FlagsProvider,
	useFeature,
	useFeatures,
	withFeature,
	behindFeature,
} = createFeatureFlags({
	SplitEhAndCm: false,
	ContentTransfer: false,
	RegenerateContextId: false,
	CreateProjectV3: true,
	DefaultRhApiKey: false,
	EnableExternalEH: false,
	ConvertProject: false,
});

export type FeatureFlags = ReturnType<typeof useFeatures>;
export type FeatureName = keyof FeatureFlags;
